export default {
	API_URL      : 'courseguide-api.madera.k12.ca.us',
	API_PROTOCOL : 'https',
	NODE_ENV     : 'production',
};
